module.exports = __webpack_public_path__ + "static/apple-d45b7b445ec6aa479be9dd9f2b627c94.png";